module.exports = __webpack_public_path__ + "assets/img/37ea86b2edc7103ac2c9b00efaa5f677.png";